import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Table } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";
import Paper from "@material-ui/core/Paper";
import danger from "../../assets/img/danger.png";

import Skeleton from "@mui/material/Skeleton";
import { translateDamageType } from "../../utils/translateDamageType";
import * as Actions from "../../store/action/claimManagement";
import { AiOutlineEye } from "react-icons/ai";
import { BsThreeDots } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import "./ReparationMission.css";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: "85vh",
  },
  tableCellSmall: {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 14,
    lineHeight: "21px",
    color: "rgba(70, 78, 95, 1)",
    borderBottom: "1px solid  rgba(0, 0, 0, 0.08)",
  },
  paper: {
    width: "100%",
    borderRadius: "11px",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
  },
  tableWrapper: {
    padding: "40px",
  },
  tableHeadRows: {
    height: "48px",
    whiteSpace: "nowrap",
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 12,

    lineHeight: "18px",
    color: "rgba(181, 181, 195, 1)",
    border: 0,
    background: "rgba(243, 246, 249, 1)",
    padding: "1%",
  },

  tableSortLabel: {
    color: "rgba(32, 29, 35, 1)",
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: 12,
    lineHeight: "18px",
  },
  titre: {
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    color: "rgba(63, 66, 84, 1)",
  },
  titreLabel: {
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 400,
    color: "rgba(32, 18, 70, 1)",
  },
  tablePagination: {
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    color: "rgba(32, 18, 70, 1)",
  },
  dateRangeContainer: {
    display: "flex",
    alignItems: "center",
    border: "0.61px solid rgba(226, 217, 239, 1)",
    background: "rgba(255, 255, 255, 1)",
    borderRadius: 5,
    padding: "5px 10px",
  },
  dateContainer: {
    border: "none",
    outline: "none",
    background: "rgba(255, 255, 255, 1)",
    borderRadius: 5,
    fontFamily: "Poppins",
    paddingLeft: "5px",
  },
  inputContainer: {
    border: "0.61px solid rgba(226, 217, 239, 1)",
    background: "rgba(255, 255, 255, 1)",
    width: "148px",
    height: "29.69px",
    borderRadius: 5,
    marginLeft: "20px",
  },
  viewBtn: {
    width: "40px",
    height: "34px",
    borderRadius: "6px",
    backgroundColor: "rgba(240, 243, 199, 1)",
    border: 0,
    lineHeight: "18px",
    color: "rgba(187, 200, 8, 1)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  taskNameColumn: {
    width: "114px",
    height: "20px",
    gap: "0px",
    fontFamily: "Poppins",
    fontSize: "10.17px",
    fontWeight: 500,
    textAlign: "left",
    color: "rgba(187, 200, 8, 1)",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  tableContent: {
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: 400,
    //lineHeight: 19.6,
    textAlign: "left",
    color: "rgba(32, 29, 35, 0.8)",
    paragraph: {
      lineHeight: "32.69px",
    },
  },
  sinistres: {
    fontFamily: "Poppins",
    fontSize: 14,
    fontWeight: 600,
    textAlign: "left",
    color: "rgba(70, 78, 95, 1)",
  },
  dropdownMenu: {
    position: "absolute",
    zIndex: 1,
    backgroundColor: "white",
    border: "0.61px solid rgba(226, 217, 239, 1)",
    //boxShadow: theme.shadows[5],
    marginRight: "110px",
    borderRadius: 6,
  },
  dropdownItem: {
    padding: theme.spacing(1),
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    color: "rgba(32, 18, 70, 1)",
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: 400,
    textAlign: "left",
  },
  naText: {
    color: "rgb(145, 145, 145)",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paperModal: {
    backgroundColor: "rgba(255, 255, 255, 1)",
    border: "none",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
    padding: theme.spacing(2, 4, 3),
    width: "459px",
    height: "175px",
  },
  modalTitle: {
    fontFamily: "Poppins",
    fontSize: "18px",
    fontWeight: 500,
    lineHeight: "21px",
    textAlign: "left",
    marginBottom: "16px",
  },
  // dialogTitle: {
  //   fontFamily: "Poppins",
  //   fontWeight: 500,
  //   fontSize: 15,
  //   color: "rgba(63, 66, 84, 1)",
  //   backgroundColor: "white",
  //   borderBottom: "1px solid #E5EAEE",
  // },
  line: {
    height: "2px",
    backgroundColor: "rgba(243, 246, 249, 1)",
    width: "100%",
    marginBottom: "16px",
  },
  selectModal: {
    width: "400px",
    height: "36px",
    borderRadius: "4px",
    border: "1px solid rgba(222, 222, 222, 1)",
  },
  CancelStyle: {
    marginLeft: "20px",
    width: "62px",
    height: "26px",
    color: "rgb(255, 54, 54)",
    backgroundColor: " rgb(255, 229, 229)",
    fontFamily: "Poppins",
    fontSize: "10.76px",
    fontWeight: 600,
    border: 0,
  },
  ajouterStyle: {
    marginLeft: "20px",
    width: "62px",
    height: "26px",
    backgroundColor: "rgba(187, 200, 8, 1)",
    color: "rgba(255, 255, 255, 1)",
    borderRadius: "5.38px",
    fontFamily: "Poppins",
    fontSize: "10.76px",
    fontWeight: 600,
    border: 0,
  },
  TextContainer: {
    display: "flex",
    justifyContent: "space-between",
    margin: "10px 15px",
  },
  dialogContent: {
    overflowY: "auto",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  cardText: {
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: 500,
    color: "rgba(128, 128, 143, 1)",
  },
  cardValue: {
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: 500,
    color: "rgba(24, 28, 50, 1)",
    textAlign: "Right",
  },
  styleInput: {
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: 500,
    border: 0,
    background: "rgba(243, 246, 249, 1)",
    color: "rgba(24, 28, 50, 0.58)",
    lineHeight: "21px",
    textAlign: "Right",
    padding: "5px",
    width: "240px",
    height: "30px",
    borderRadius: "4px",
  },
  card: {
    backgroundColor: "white",
    borderRadius: "8px",
    width: "100%",
    height: "680px",
    border: "0.61px solid rgba(226, 217, 239, 1)",
  },
  dialogPaper: {
    width: "700px",
    overflow: "hidden",
  },
  selectInput: {
    border: "0.61px solid rgba(226, 217, 239, 1)",
    background: "rgba(255, 255, 255, 1)",
    width: "148px",
    height: "29.69px",
    borderRadius: 5,
    marginLeft: "20px",
  },
  selectInputDialog: {
    width: "240px",
    border: "0",
    padding: "5px",
    background: "rgba(243, 246, 249, 1)",
    height: "29.69px",
    borderRadius: 5,
  },
  optionLabel: {
    width: "150px",
    padding: theme.spacing(1),
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    color: "rgba(32, 18, 70, 1)",
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: 400,
    textAlign: "left",
  },
  dialogTitle: {
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: 15,
    color: "rgba(63, 66, 84, 1)",
    backgroundColor: "white",
    borderBottom: "1px solid #E5EAEE",
  },
  optionItem: {
    width: "150px",
    padding: theme.spacing(1),
    cursor: "pointer",
    backgroundColor: "white",
    color: "rgba(32, 18, 70, 1)",
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: 400,
    textAlign: "left",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

export default function ReparationMissionList(props) {
  const navigate = useNavigate();
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [inputType, setInputType] = useState("text");
  const [dateRange, setDateRange] = useState({ fromDate: "", toDate: "" });
  const [claimNumber, setClaimNumber] = useState("");
  const [reparationMissions, setReparationMissions] = useState([]);
  const [Immatriculation, setImmatriculation] = useState("");
  function handleViewClick(reparationMission) {
    console.log(reparationMission.associatedClaimNumber);
    navigate(`/sinistre/${reparationMission.claimDetails._id}`);
  }

  function handleClaimNumberChange(e) {
    setClaimNumber(e.target.value);
  }

  function handleImmatChange(e) {
    setImmatriculation(e.target.value);
  }

  useEffect(() => {
    async function fetchReparationMissions() {
      setLoading(true);
      try {
        const data =
          await Actions.getReparationMissionsForClaimsAwaitingReparation();
        setReparationMissions(data);
      } catch (error) {
        console.error("Failed to fetch reparation missions:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchReparationMissions();
  }, []);
  const filteredReparationMissions = reparationMissions.filter((mission) => {
    const fromDate = new Date(dateRange.fromDate);
    const toDate = new Date(dateRange.toDate);
    const missionDate = new Date(
      mission.serviceProposal.estimatedCarDeposalDate
    );

    const isWithinDateRange =
      (!dateRange.fromDate || missionDate >= fromDate) &&
      (!dateRange.toDate || missionDate <= toDate);

    return (
      mission.associatedClaimNumber
        .toLowerCase()
        .includes(claimNumber.toLowerCase()) &&
      mission.claimDetails.insuredCarLicensePlate
        .toLowerCase()
        .includes(Immatriculation.toLowerCase()) &&
      isWithinDateRange
    );
  });

  const headRows = [
    { id: "claimNumber", align: "center", label: "N° Sinistre", width: "30%" },
    {
      id: "managementType",
      align: "left",
      label: "Mode de Gestion",
      width: "10%",
    },
    {
      id: "Immatriculation",
      align: "center",
      label: "Immatriculation",
      width: "20%",
    },
    {
      id: "provisionedEntryDate",
      align: "center",
      label: "Date d entrée prévisonelle",
      width: "20%",
    },
    { id: "repairer", align: "center", label: "Réparateur", width: "10%" },
    { id: "", align: "center", label: "", width: "20%" },
  ];

  function getDateFromString(dateString) {
    if (!dateString) return "";
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${day}/${month}/${year}`;
  }

  function renderField(field) {
    return field ? field : <span className={classes.naText}>N/A</span>;
  }

  const handleDateChange = (e, type) => {
    const dateValue = e.target.value;
    if (type === "from") {
      setDateRange((prevState) => ({ ...prevState, fromDate: dateValue }));
    } else {
      setDateRange((prevState) => ({ ...prevState, toDate: dateValue }));
    }
  };
  function isPastDate(dateString) {
    const today = new Date();
    const date = new Date(dateString);
    return date < today;
  }

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <div className={classes.tableWrapper}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "40px",
            }}
          >
            <div className={classes.titre} style={{ width: "18%" }}>
              Liste des missions de réparations
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "60%",
                justifyContent: "space-between",
              }}
            >
              <div
                className={classes.titreLabel}
                style={{ marginRight: "15px", whiteSpace: "nowrap" }}
              >
                Filtrer par
              </div>
              <div
                className={classes.titreLabel}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "15px",
                }}
              >
                Date
                <div
                  className={classes.dateRangeContainer}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "15px",
                  }}
                >
                  <span style={{ marginRight: "5px" }}>De</span>
                  <input
                    type={inputType}
                    className={classes.dateContainer}
                    onFocus={() => setInputType("date")}
                    onBlur={() => setInputType("text")}
                    style={{ width: "110px" }}
                    onChange={(e) => handleDateChange(e, "from")}
                  />
                  <span style={{ marginRight: "1px" }}>A</span>
                  <input
                    type={inputType}
                    className={classes.dateContainer}
                    onFocus={() => setInputType("date")}
                    onBlur={() => setInputType("text")}
                    style={{ width: "110px" }}
                    onChange={(e) => handleDateChange(e, "to")}
                  />
                </div>
              </div>
              <div
                className={classes.titreLabel}
                style={{
                  display: "flex",
                  alignItems: "center",
                  whiteSpace: "nowrap",
                }}
              >
                N° Sinistre
                <input
                  type="text"
                  className={classes.inputContainer}
                  style={{ width: "120px", marginLeft: "10px" }}
                  onChange={handleClaimNumberChange}
                />
              </div>
              <div
                className={classes.titreLabel}
                style={{
                  display: "flex",
                  alignItems: "center",
                  whiteSpace: "nowrap",
                }}
              >
                Immatriculation
                <input
                  type="text"
                  className={classes.inputContainer}
                  style={{ width: "120px", marginLeft: "10px" }}
                  onChange={handleImmatChange}
                />
              </div>
            </div>
          </div>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size="small"
          >
            <tr>
              {headRows.map((row) => (
                <TableCell
                  key={row.id}
                  height="43px"
                  align={row.align}
                  style={{
                    width: row.width,
                  }}
                  className={classes.tableHeadRows}
                >
                  {row.label}
                </TableCell>
              ))}
            </tr>
            {loading
              ? [...Array(10)].map((_, index) => (
                  <tr key={index} hover style={{ height: "48px" }}>
                    <TableCell align="left" className={classes.tableCellSmall}>
                      <Skeleton animation="wave" />
                    </TableCell>
                    <TableCell align="left" className={classes.tableCellSmall}>
                      <Skeleton animation="wave" />
                    </TableCell>
                    <TableCell align="left" className={classes.tableCellSmall}>
                      <Skeleton animation="wave" />
                    </TableCell>
                    <TableCell align="left" className={classes.tableCellSmall}>
                      <Skeleton animation="wave" />
                    </TableCell>
                    <TableCell align="left" className={classes.tableCellSmall}>
                      <Skeleton animation="wave" />
                    </TableCell>
                    <TableCell align="right" className={classes.tableCellSmall}>
                      <button className={classes.viewBtn}>
                        <BsThreeDots />
                      </button>
                      <button
                        className={classes.viewBtn}
                        style={{ marginLeft: "7px" }}
                      >
                        <AiOutlineEye />
                      </button>
                    </TableCell>
                  </tr>
                ))
              : filteredReparationMissions.map((reparationMission, index) => {
                  return (
                    <tr
                      key={reparationMission.missionNumber || index}
                      hover
                      style={{
                        height: "50px",
                        backgroundColor: "rgba(255, 255, 255, 1)",
                      }}
                    >
                      <TableCell
                        align="center"
                        className={classes.tableCellSmall}
                      >
                        <div style={{ display: "flex" }}>
                          <div style={{ width: "50%" }}>
                            {renderField(
                              reparationMission.associatedClaimNumber
                            )}
                          </div>
                          <div
                            style={{
                              height: "26px",
                              borderRadius: "51px",
                              background: "rgba(240, 243, 199, 1)",
                              textAlign: "center",
                              padding: "5px",
                              fontFamily: "Poppins",
                              fontSize: "10.17px",
                              fontWeight: 500,
                              lineHeight: "15.26px",
                              color: "rgba(187, 200, 8, 1)",
                            }}
                          >
                            {renderField(
                              translateDamageType(
                                reparationMission.claimDetails.damageType
                              )
                            )}
                          </div>
                        </div>
                      </TableCell>
                      <TableCell
                        align="center"
                        className={classes.tableCellSmall}
                      >
                        <div
                          style={{
                            height: "26px",
                            borderRadius: "51px",
                            background: "rgba(240, 243, 199, 1)",
                            textAlign: "center",
                            padding: "5px",
                            fontFamily: "Poppins",
                            fontSize: "10.17px",
                            fontWeight: 500,
                            lineHeight: "15.26px",
                            color: "rgba(187, 200, 8, 1)",
                          }}
                        >
                          {renderField(
                            reparationMission.claimDetails.managementType
                          )}
                        </div>
                      </TableCell>
                      <TableCell
                        align="center"
                        className={classes.tableCellSmall}
                      >
                        {renderField(
                          reparationMission.claimDetails.insuredCarLicensePlate
                        )}
                      </TableCell>
                      <TableCell
                        align="center"
                        className={classes.tableCellSmall}
                        style={{
                          color: isPastDate(
                            reparationMission.serviceProposal
                              .estimatedCarDeposalDate
                          )
                            ? "#C81F08A8"
                            : "inherit",
                        }} 
                      >
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent:'center' }}>
    {isPastDate(reparationMission.serviceProposal.estimatedCarDeposalDate) && (
      <img src={danger} style={{ width: "15px", marginRight: "8px" }} alt="danger" />
    )}
    {renderField(
      getDateFromString(
        reparationMission.serviceProposal.estimatedCarDeposalDate
      )
    )}
  </div>
                      </TableCell>

                      <TableCell
                        align="center"
                        className={classes.tableCellSmall}
                      >
                        {renderField(
                          reparationMission.repairerDetails.organizationName
                        )}
                      </TableCell>

                      <TableCell
                        align="right"
                        className={classes.tableCellSmall}
                      >
                        <button
                          style={{
                            width: "61px",
                            height: "34px",
                            borderRadius: "6px",
                            background: "rgba(187, 200, 8, 1)",
                            border: 0,
                            fontFamily: "Poppins",
                            fontSize: "12px",
                            fontWeight: 600,
                            lineHeight: "18px",
                            color: "rgba(255, 255, 255, 1)",
                          }}
                          onClick={() => handleViewClick(reparationMission)}
                        >
                          Voir
                        </button>
                      </TableCell>
                    </tr>
                  );
                })}
          </Table>
        </div>
      </Paper>
    </div>
  );
}
